import { render, staticRenderFns } from "./BInputLimited.vue?vue&type=template&id=50e98da6&scoped=true&"
import script from "./BInputLimited.vue?vue&type=script&lang=js&"
export * from "./BInputLimited.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e98da6",
  null
  
)

export default component.exports